import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  MockBoardingPassResult,
} from '@dapi/sdk/spec';
import {
  acceptedjourney2Adt2Seg,
  journey2Adt2Seg,
  noItemToPayError,
  paymentRecords,
  servicesToPay,
} from '../../mock/data';
import {
  authorization,
} from '../../mock/dictionaries';
import {
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';
import {
  servicesResponseBoarding,
  throughPricingServiceCatalog,
} from './common/services';

export const journeyElementIds: string[] = journey2Adt2Seg[0].journeyElements.map((je: JourneyElementCommon) => je.id);
const seatmap = retrieveSeatMapsJourneyDriven(journey2Adt2Seg[0], journey2Adt2Seg[0].travelers.map((t) => t.id).filter((id): id is string => !!id));
const bp: MockBoardingPassResult[] = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.TSA
}], {
  journeyElementIds
}).items;

/**
 * Connection Flights
 * 1 Journey - 2 flights -2 ADT
 * Through Pricing
 */
export const ow1Journey1AdtThroughPricing: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(bp, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(servicesToPay),
    createMockData(servicesToPay),
    createMockData(servicesToPay),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError])
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(acceptedjourney2Adt2Seg, 201)],
  retrieveJourney: [
    createMockData(acceptedjourney2Adt2Seg)
  ],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [createMockDataWithResponse(journey2Adt2Seg, 201),
    createMockDataWithResponse([acceptedjourney2Adt2Seg], 201)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  servicesCatalogueFromJourney: [createMockData(throughPricingServiceCatalog)
  ],
  addJourneyServices: [createMockDataWithResponse(servicesResponseBoarding, 201)],
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)]
};
